export enum TRANSCRIPT_STATUS {
  NO_TRANSCRIPT = "NoTranscript",
  AUTOMATIC_TRANSCRIPT = "AutomaticTranscript",
  SMART_TRANSCRIPT = "SmartTranscript"
}

export enum TRANSCRIPT_EDIT_MODE {
  VIEW = "view",
  EDIT = "edit"
}

export enum TRANSCRIPTS_MODE {
  QUESTIONS_MODE = "questionsMode",
  EXPERTS_MODE = "expertsMode"
}

export enum VOICE_RECORDING_ERROR {
  PERMISSION_DENIED = "PermissionDenied",
  UNSUPPORTED_MIME_TYPE = "UnsupportedMimeType",
  NO_MICROPHONE = "NoMicrophone",
  MICROPHONE_IN_USE = "MicrophoneInUse",
  INSECURE_CONTEXT = "InsecureContext",
  RECORDING_FAILED = "RecordingFailed"
}

export enum CURRENCIES_SYMBOLS {
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP"
}

export enum EXPERT_PRICING_TYPE {
  CREDIT_PACKAGE = "CreditPackage",
  INTRODUCTORY_FEE_MARKUP = "IntroductoryFeeMarkup"
}

export enum APP_TRACKING_ROUTES {
  ACCOUNT = "account",
  BOOK = "book",
  FOLLOW_UP = "follow_up",
  CHAT = "chat",
  DASHBOARD = "dashboard",
  DASHBOARD_PANEL = "dashboard_panel",
  DISCOVER = "discover",
  EXPERT_AVAILABILITY = "expert_availability",
  FIRST_PAGE = "first_page",
  INBOX = "inbox",
  NETWORK = "network",
  PROJECT_CALENDAR = "project_calendar",
  PROJECTS = "projects",
  SHARE_BOOKING_LINK = "SharedBookingLink",
  TEAM_MEMBERS = "team_members",
  REGISTER = "register",
  SURVEY_QUALIFIED = "survey-qualified",
  SURVEY_NOT_QUALIFIED = "survey-not-qualified",
  SURVEY_FEEDBACK = "survey-feedback",
  PUBLIC_CUSTOMER_REPORT = "public_customer_report"
}

export enum REFERRAL_SUB_STATE {
  PENDING = "Pending",
  ACCEPT = "Accept",
  REJECT = "Reject",
  UI_NOT_REQUIRED = "NotRequired" // Only used for UI rendering
}

export enum REFERRAL_COMPLIANCE_STATE {
  PENDING = "Pending",
  ACCEPT = "Accept",
  REJECT = "Reject"
}

export enum REFERRAL_STATUS {
  SHORTLIST = "Shortlist",
  CANDIDATE = "Candidate",
  ACCEPT = "Accept",
  REJECT = "Reject"
}

export enum EXPERT_ONBOARDING_STAGES {
  CONTACT_DETAILS = "contactDetails",
  WORK_HISTORY = "workHistory",
  LINKEDIN_URL = "linkedinUrl",
  SOFTWARE_REVIEWS = "softwareReviews",
  SUCCESS = "success"
}

export enum FeedbackType {
  Call = "Call",
  Canopy = "Canopy",
  SoftwareReview = "SoftwareReview"
}

export enum ANT_TABLE_ACTIONS {
  SORT = "sort",
  FILTER = "filter",
  PAGINATE = "paginate"
}

export enum REWARDS_PAYOUT_STATUS {
  PENDING = "Pending",
  PAID = "Paid"
}

// Values of the `source` property on the rewards_join_clicked Mixpanel event.
export enum REWARDS_JOIN_SOURCE {
  PANEL = "panel",
  LOCKED_CARD = "locked_card",
  REWARDS_LIST = "rewards_list",
  EXPERIENCE_BANNER = "experience_banner",
  STEPPER_HEADER = "stepper_header"
}

export enum REWARDS_INVITATION_STATUS {
  SENT = "Sent",
  SOFTWARE_REVIEWS_PENDING = "SoftwareReviewsPending",
  SOFTWARE_REVIEWS_SUBMITTED = "SoftwareReviewsSubmitted",
  JOINED = "Joined"
}

export enum REWARDS_TABLE_ROW_TYPE {
  DATE = "date",
  EARNING = "earning"
}

export enum REWARDS_IMPACT {
  LOW = "Low",
  HIGH = "High"
}

export enum RewardsPerformanceOrderBy {
  TotalEarned = "TotalEarned",
  CompanyName = "CompanyName"
}

export enum EXPERT_REWARD_EARNING_TYPE {
  SOFTWARE_REVIEW = "SoftwareReview",
  NEW_JOINER = "NewJoiner",
  REWARDS_REFERRAL = "RewardsReferral",
  PROJECT_APPLICATION = "ProjectApplication",
  CLIENT_SOFTWARE_REVIEW_REQUEST = "ClientSoftwareReviewRequest"
}

export enum REWARD_PROGRAM_BADGE_TYPE {
  ACTIVE = "active",
  COMING_SOON = "comingSoon",
  NO_REFERRALS = "noReferrals",
  LOCKED = "locked",
  ENABLED = "enabled"
}

export enum REWARD_PROGRAM_KEY {
  STANDARD_REVIEWS = "standardReviews",
  IN_DEPTH_REVIEWS = "inDepthReviews",
  SIGNUP_REFERRALS = "signupReferrals"
}

export enum REFER_PEER_FORM_FIELD {
  EMAILS = "emails"
}

export enum REFER_PEER_MODAL_SOURCE {
  SOFTWARE_REVIEW_STEPPER = "software_review_stepper",
  CTA = "cta",
  URL = "url"
}

export enum AI_ANALYSIS_SOURCE {
  SOFTWARE_REVIEWS_PAGE = "software_reviews_page",
  EXPERT_DASHBOARD = "expert_dashboard"
}

export enum INSIGHT_TIP_KEY {
  NICHE = "niche",
  SPECIALIZED = "specialized",
  DAILY = "daily",
  LESSER_KNOWN = "lesser_known"
}

export enum StepKeys {
  WORK_HISTORY_SELECTION = "workHistorySelection",
  COMPANY_SELECTION = "companySelection",
  STILL_USING = "stillUsing",
  NOT_USED_DETAILS = "notUsedDetails",
  PERSONA = "persona",
  IMPLEMENTATION = "implementation",
  PERSONA_AND_IMPLEMENTATION = "personaAndImplementation",
  BUDGET = "budget",
  SATISFACTION = "satisfaction",
  RENEWAL = "renewal",
  COMPETITORS = "competitors",
  OTHER_COMMENTS = "otherComments",
  FINAL_DETAILS = "finalDetails",
  QUALITATIVE_BUYING_PROCESS = "qualitativeBuyingProcess",
  QUALITATIVE_SPEND_BREAKDOWN = "qualitativeSpendBreakdown",
  QUALITATIVE_RELY_REASONS = "qualitativeRelyReasons",
  QUALITATIVE_SWITCH_FACTORS = "qualitativeSwitchFactors",
  QUALITATIVE_NPS_JUSTIFICATION = "qualitativeNpsJustification"
}

export enum OutdatedUpdateBranchStep {
  Choice = "choice",
  NotUsedDetails = "notUsedDetails",
  Review = "review"
}

export enum SOFTWARE_REVIEW_STEPPER_PHASE {
  QUANTITATIVE = "quantitative",
  QUALITATIVE_OFFER = "qualitativeOffer",
  QUALITATIVE = "qualitative"
}

export enum WorkHistoryDisabledReason {
  NO_COMPANY = "noCompany"
}

export enum ProgressPosition {
  FIRST = "first",
  ALMOST_THERE = "almostThere",
  LAST = "last",
  MIDDLE = "middle"
}

export enum AddPositionFieldNames {
  EMPLOYED_STATUS = "employedStatus",
  TITLE = "title",
  COMPANY = "company",
  FROM = "from"
}

export enum BRAND_LOGO_VARIANT {
  Full = "full",
  FullWhite = "fullWhite",
  Mark = "mark",
  MarkSquare = "markSquare",
  MarkWhite = "markWhite",
  Avatar = "avatar"
}

export enum AUTH_BADGE_VARIANT {
  Green = "green",
  Blue = "blue"
}

export enum AUTH_PANEL_THEME {
  ExpertPurple = "expert-purple",
  ClientDark = "client-dark",
  SelectionPurple = "selection-purple"
}

export enum AUTH_PANEL_IMAGE_PLACEMENT {
  Bleed = "bleed",
  Inset = "inset"
}

export enum COMPANY_SEARCH_SOURCE {
  ProjectList = "project_list",
  ProjectDashboard = "project_dashboard",
  CalendarPage = "calendar_page",
  TranscriptsPage = "transcripts_page",
  CanopiesPage = "canopies_page",
  ReferralsPage = "referrals_page",
  CustomerDiscovery = "customer_discovery",
  CustomerLibraryHeader = "customer_library_header"
}

export enum MCP_MODAL {
  None = "none",
  Intro = "intro",
  Instructions = "instructions"
}

export enum MCP_COPY_TARGET {
  ServerUrl = "server_url",
  ConnectorName = "connector_name"
}

export enum MCP_INSTRUCTIONS_SOURCE {
  Banner = "banner",
  IntroModal = "intro_modal"
}
